/* eslint-disable */
/* istanbul ignore file */
import React, { type Dispatch, useCallback, useState } from 'react'
import { CircularProgress } from '@mui/material'
import LanguageStrings from '../../../i18n/locales'
import { connect, type ConnectedProps, useSelector } from 'react-redux'
import { assetDeleteCampaign } from '../../asset-managament/redux/actionCreator'
import { useNavigate } from 'react-router-dom'
import GenericModal from '../../../components/Modal'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { APIConfiguration } from '../../../utils/apiConfiguration'
import { type RootState } from '../../../store'
import { Tooltip } from '@mui/material'
import { useAuth } from 'react-oidc-context'
import { MemoManagementInfoHeader } from '../../common/ManagementInfoHeader'

const AssetInformationStrings = LanguageStrings().GatewayManagementCollectionStrings.AssetInformationComponent
const httpStatus = APIConfiguration

const AssetInformation = (props: PropsFromRedux & { parentSiteId: any, assetInfo: any, imageBinaryData: any}): JSX.Element => {
  const auth = useAuth()
  const navigate = useNavigate()
  const [selectedAssetId, setSelectedAssetId] = useState('')
  const [confirmDeletePopup, setConfirmDeletePopup] = useState(false)
  const [showDeleteStatus, setShowDeleteStatus] = useState(false)
  const assetDeleteStatus = useSelector(
    (state: RootState) => state.assetDeleteState
  )

  const handleEdit = useCallback(()=>{
    navigate(`/edit-asset/${props.assetInfo.assetInfo.id}`, {
      state: {
        assetId: props.assetInfo.assetInfo.id,
        assetName: props.assetInfo.assetInfo.name,
        assetDescription: props.assetInfo.assetInfo.description,
        gatewayId: props.assetInfo.assetInfo.gateway_id,
        gatewayName: props.assetInfo.assetInfo.gateway_name,
        parentAssetId: props.parentSiteId
      }
    })
  },[props])

  const handleDelete = useCallback(()=>{
    setSelectedAssetId(props.assetInfo.assetInfo.id)
    setConfirmDeletePopup(true)
  },[props])

  const handleDeleteCampaign = (): void => {
    setConfirmDeletePopup(false)
    setShowDeleteStatus(true)
    props.assetDeleteCampaign(selectedAssetId, auth.user?.profile.sub ?? '')
  }

  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 40) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 40)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  const handleDeleteCampaignWithFailure = (): JSX.Element => {
    /* istanbul ignore next */
    if (assetDeleteStatus.httpStatus === httpStatus.SUCCESS_HTTP_STATUS) {
      return (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={AssetInformationStrings.successfullyDeleted}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate(`/thermal-asset-list/${props.parentSiteId}`) // Redirect after closing the modal
          }}
          onClose={() => {
            setShowDeleteStatus(false)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate(`/thermal-asset-list/${props.parentSiteId}`) // Redirect after closing the modal
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
              {AssetInformationStrings.FullMsgAssetDeletedSuccessfully}
          </p>
        </GenericModal>
      )
    } else if (assetDeleteStatus.isLoading) {
      return (
        <GenericModal title={'Loading...'}>
          <div className="CircularprogressAmi">
            <CircularProgress />
          </div>
        </GenericModal>
      )
    } else if (assetDeleteStatus.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {assetDeleteStatus.error} </p>
        </GenericModal>
      )
    } else if (assetDeleteStatus.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="Unauthorized" />
        </div>
      )
    } else if (assetDeleteStatus.httpStatus === httpStatus.ACCESS_FORBIDDEN_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="accessForbidden" />
        </div>
      )
    } else {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {assetDeleteStatus.error} </p>
        </GenericModal>
      )
    }
  }

  return (
      <>
        <MemoManagementInfoHeader 
          title={AssetInformationStrings.AssetInformation}
          binaryData={props.imageBinaryData?.binaryData} 
          name={props?.assetInfo?.assetInfo?.name} 
          description={props?.assetInfo?.assetInfo?.description} 
          createdOn={props?.assetInfo?.assetInfo?.install_date}
          handleEdit={handleEdit}
          handleDelete={handleDelete} />

        {confirmDeletePopup && (
          <GenericModal
            width="600px"
            height="260px"
            buttonTypeNegative="hollow"
            title={'Delete Asset'}
            LabelPositive="Confirm"
            LabelNegative="Cancel"
            onClickPositive={handleDeleteCampaign}
            onClose={() => { setConfirmDeletePopup(false) }}
            onClickNegative={() => { setConfirmDeletePopup(false) }}
          >
            <p style={{ paddingTop: '1.2em' }}>
              {AssetInformationStrings.DeleteConfirmation}<br/><br/>
              {AssetInformationStrings.DeleteConfirmationWarning}
            </p>
          </GenericModal>
        )}
        {
            /* istanbul ignore next */
            showDeleteStatus && handleDeleteCampaignWithFailure()
        }
    </>
  )
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  assetDeleteCampaign: (selectedAssetId: string, subId: string) => { dispatch(assetDeleteCampaign(selectedAssetId, subId)) }
})

const connector = connect(null, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AssetInformation)
